export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_CRM_API_URL: import.meta.env.VITE_CRM_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
};
